import { AclRule } from 'vue-acl'

import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

import ConsultaForm from './components/consulta/Form.vue'

import EmpresaList from './components/empresas/List.vue'
import EmpresaForm from './components/empresas/Form.vue'

import UserList from './components/usuarios/List.vue'
import UserForm from './components/usuarios/Form.vue'

import FechamentoList from './components/fechamento/List.vue'

/* Rotas */
const routes = [
{
  path: '/login',
  component: LoginView,
  meta: {
    rule: new AclRule('public').generate()
  }
},
{
  path: '/',
  component: DashView,
  meta: {
    requiresAuth: true,
    rule: new AclRule('usuario.getUserCurrent').generate()
  },
  children: [
  {
    path: 'consulta',
    alias: '',
    component: ConsultaForm,
    name: 'Consulta',
    meta: {
      description: 'Consulta',
      rule: new AclRule('usuario.getUserCurrent').generate()
    }
  },   

  /* USERS ROUTES */
  { 
    path: 'usuarios',
    component: UserList,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Usuários do Sistema',
      rule: new AclRule('usuario.getAllPaginate').generate()
    }
  }, {
    path: 'usuarios/novo',
    component: UserForm,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Novo Usuário',
      rule: new AclRule('usuario.create').generate()
    }
  }, {
    path: 'usuarios/atualizacao/:idUsuario',
    component: UserForm,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Atualização do Usuário',
      rule: new AclRule('usuario.update').generate()
    }
  },

   /* EMPRESAS ROUTES */
  { 
    path: 'empresas',
    component: EmpresaList,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Empresas',
      rule: new AclRule('usuario.getAllPaginate').generate()
    }
  }, {
    path: 'empresas/novo',
    component: EmpresaForm,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Nova Empresa',
      rule: new AclRule('usuario.create').generate()
    }
  }, {
    path: 'empresas/atualizacao/:idUsuario',
    component: EmpresaForm,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Atualização da Empresa',
      rule: new AclRule('usuario.update').generate()
    }
  },

   /* FECHAMENTOS ROUTES */
  { 
    path: 'fechamento',
    component: FechamentoList,
    name: 'PREMIUM CONSULTA',
    meta: {
      description: 'Fechamento',
      rule: new AclRule('usuario.getAllPaginate').generate()
    }
  }
  ]
}, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
  ]

  export default routes



// WEBPACK FOOTER //
// ./src/routes.js